import { useState } from 'react'
import { useStore } from '../../stores/useStore'

export default function Sequencer() {
  const tracks = useStore((state) => state.tracks)
  const transport = useStore((state) => state.transport)
  const toggleStep = useStore((state) => state.toggleStep)
  const setStepVelocity = useStore((state) => state.setStepVelocity)
  const clearSequence = useStore((state) => state.clearSequence)
  const randomizeSequence = useStore((state) => state.randomizeSequence)
  const applyPreset = useStore((state) => state.applyPreset)
  const [dragging, setDragging] = useState<{ trackId: string; stepIndex: number } | null>(null)

  const currentStep = Math.floor(transport.position) % 16

  const handleStepMouseDown = (trackId: string, stepIndex: number) => {
    toggleStep(trackId, stepIndex)
    setDragging({ trackId, stepIndex })
  }

  const handleStepMouseEnter = (trackId: string, stepIndex: number) => {
    if (dragging && dragging.trackId === trackId && dragging.stepIndex !== stepIndex) {
      toggleStep(dragging.trackId, stepIndex)
      setDragging((prev) => (prev ? { ...prev, stepIndex } : null))
    }
  }

  const handleWheel = (trackId: string, stepIndex: number, delta: number) => {
    const track = tracks.find((t) => t.id === trackId)
    if (!track) return
    const step = track.steps[stepIndex]
    if (!step) return
    setStepVelocity(trackId, stepIndex, step.velocity + delta * 5)
  }

  return (
    <div className="sequencer">
      <div className="sequencer-header">
        <div className="sequencer-label">TRACK / STEP</div>
        <div className="steps-header">
          {Array.from({ length: 16 }).map((_, i) => (
            <div
              key={i}
              className={`step-header ${i % 4 === 0 ? 'beat' : ''}`}
              style={{ width: '36px', textAlign: 'center' }}
            >
              {i + 1}
            </div>
          ))}
        </div>
        <div style={{ width: '180px' }} />
      </div>

      <div className="pattern-buttons">
        <button className="btn" onClick={() => tracks.forEach((t) => applyPreset(t.id, 'kick'))}>Kick</button>
        <button className="btn" onClick={() => tracks.forEach((t) => applyPreset(t.id, 'hat'))}>Hat</button>
        <button className="btn" onClick={() => tracks.forEach((t) => applyPreset(t.id, 'bass'))}>Bass</button>
        <button className="btn" onClick={() => tracks.forEach((t) => randomizeSequence(t.id))}>Random</button>
        <button className="btn btn-danger" onClick={() => tracks.forEach((t) => clearSequence(t.id))}>Clear</button>
      </div>

      <div className="sequencer-grid">
        {tracks.map((track, trackIndex) => {
          const trackIdx = trackIndex % 2 === 0
          return (
            <div key={track.id} className={`sequencer-track ${trackIdx ? 'even' : ''}`}>
              <div className="track-info">
                <div className="track-color" style={{ background: track.color || '#118C9B' }} />
              <input type="text" value={track.name} onChange={(e) => useStore.getState().updateTrack(track.id, { name: e.target.value })} />
              </div>
              <div className="steps">
                {track.steps.map((step) => {
                  const isCurrentStep = step.index % 16 === currentStep
                  const velocityHeight = Math.max(4, (step.velocity / 100) * 22)
                  return (
                    <button
                      key={step.index}
                      className={`step-btn ${step.enabled ? 'active' : ''} ${isCurrentStep && track.enabled && !track.muted ? 'playing' : ''}`}
                      onMouseDown={() => handleStepMouseDown(track.id, step.index)}
                      onMouseEnter={() => handleStepMouseEnter(track.id, step.index)}
                      onWheel={(e) => {
                        e.preventDefault()
                        handleWheel(track.id, step.index, e.deltaY > 0 ? -1 : 1)
                      }}
                      title={`Velocity: ${step.velocity}`}
                    >
                      <div
                        className="velocity-bar"
                        style={{ height: `${velocityHeight}px` }}
                      />
                    </button>
                  )
                })}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
